function isPlainObject(value) {
  return Boolean(value) && typeof value === 'object' && !Array.isArray(value)
}

function normalizePositiveInteger(value, fallbackValue = null) {
  const numericValue = Number(value)

  if (!Number.isFinite(numericValue) || numericValue <= 0) {
    return fallbackValue
  }

  return Math.round(numericValue)
}

function normalizeTier(value) {
  if (typeof value !== 'string') {
    return null
  }

  const normalizedValue = value.trim().toLowerCase()
  return normalizedValue || null
}

export function normalizeVideoCallQualityProfile(profile) {
  if (!isPlainObject(profile)) {
    return null
  }

  const width = normalizePositiveInteger(profile.width)
  const height = normalizePositiveInteger(profile.height)
  const frameRate = normalizePositiveInteger(profile.frameRate)
  const bitrateKbps = normalizePositiveInteger(profile.bitrateKbps)

  if (!width || !height || !frameRate || !bitrateKbps) {
    return null
  }

  return {
    width,
    height,
    frameRate,
    bitrateKbps,
  }
}

export function normalizeResolvedVideoCallQuality(videoQuality) {
  if (!isPlainObject(videoQuality)) {
    return null
  }

  const publishProfile = normalizeVideoCallQualityProfile(videoQuality.publishProfile)
  const lowStreamProfile = normalizeVideoCallQualityProfile(videoQuality.lowStreamProfile)

  if (!publishProfile) {
    return null
  }

  return {
    source:
      typeof videoQuality.source === 'string' && videoQuality.source.trim()
        ? videoQuality.source.trim()
        : 'default',
    participantRole:
      typeof videoQuality.participantRole === 'string' && videoQuality.participantRole.trim()
        ? videoQuality.participantRole.trim()
        : 'default',
    tier: normalizeTier(videoQuality.tier) || 'sd',
    publishProfile,
    lowStreamProfile,
    enableDualStream: videoQuality.enableDualStream === true,
    preferHighQualityRemote: videoQuality.preferHighQualityRemote !== false,
  }
}
